<!--
<div class="row drawer-content-header mb-0">
    <div class="col px-3 pt-3 justify-content-end d-flex">
        <button (click)="close()" type="button" class="btn btn-slightly-darker btn-rounded btn-md text-uppercase mr-2 align-self-center">
            {{ 'Cancel' | translate }}
        </button>
        <button (click)="save(true);" class="align-self-center btn btn-md btn-primary-extra-light mr-2 text-uppercase">
            {{ 'Skip release note and publish' | translate }}
        </button>
        <button (click)="save();" class="align-self-center btn btn-md btn-outline-primary text-uppercase">
            {{ 'Publish' | translate }}
        </button>
    </div>
</div>
-->
<div class="row drawer-content drawer-direct-content pt-3">
    <div class="col">
        <h4 class="mb-3">Release note <span class="badge badge-outline-dark ml-2">v{{formatNewVersion()}}</span></h4>
        <div class="card-new">
            <div class="form-group mt-0">
                <label class="input-label field-required">Title</label>
                <input class="form-control" [(ngModel)]="releaseNote.title">
            </div>
            <div class="form-group">
                <label class="input-label">Description</label>
                <textarea class="form-control" [(ngModel)]="releaseNote.description"></textarea>
            </div>
            <div class="form-group">
                <label class="input-label field-required">Type of publication</label>
                <release-note-types-handler [readyOnly]="false" (setSelectedTypes)="updateTypes($event)"></release-note-types-handler>
            </div>
        </div>
    </div>
</div>